var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('FilterFields', {
    attrs: {
      "fields": [{
        type: 'text',
        label: 'Nome',
        field: 'nome'
      }, {
        type: 'select',
        label: 'Status',
        field: 'ativo',
        options: ['Todos', 'Ativo', 'Inativo']
      }]
    }
  }), _c('TableApp', {
    ref: "ambientes",
    attrs: {
      "titulo": "Ambientes",
      "acaoBtn": "/#/restauranteAmbientes/novo",
      "textoBtn": "Novo",
      "api-url": "/restaurante/ambientes",
      "fields": _vm.fields,
      "perPage": 10
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'ativo' ? _c('span', [props.rowData.ativo == true ? _c('span', {
          staticClass: "label label-lg label-inline label-light-success"
        }, [_vm._v("Ativo")]) : _c('span', {
          staticClass: "label label-lg label-inline label-light-danger"
        }, [_vm._v("Inativo")])]) : _vm._e(), props.field == 'actions' ? _c('span', [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative",
            "width": "180px"
          }
        }, [_c('div', {
          staticClass: "dropdown dropdown-inline"
        }, [_c('router-link', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Mesas',
            expression: "'Mesas'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-light-primary btn-hover-primary btn-icon mr-2",
          attrs: {
            "to": {
              name: 'restauranteAmbientesMesas',
              params: {
                ambienteId: props.rowData.id
              },
              query: {
                ambiente_nome: props.rowData.nome
              }
            }
          }
        }, [_c('TableFurniture', {
          attrs: {
            "size": 16,
            "title": "Mesas"
          }
        })], 1), _c('router-link', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Editar',
            expression: "'Editar'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          attrs: {
            "to": {
              name: 'restauranteAmbientesEditar',
              params: {
                id: props.rowData.id
              }
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "size": 16,
            "title": "Editar"
          }
        })], 1), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Excluir',
            expression: "'Excluir'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.excluir(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)], 1)])])]) : _vm._e()];
      }
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };